import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Api from 'api/api';
import { TrackEventRequest } from 'api/interfaces/request';
import {
  TrackEventCategoryEnum,
  TrackEventTypeEnum,
} from 'config/TrackEventType';
import { STORAGE_INVITATION_EMAIL_EVENT_TRACKING } from 'config/constants';

export const EmailContactSupport = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const hasRun = sessionStorage.getItem(
    STORAGE_INVITATION_EMAIL_EVENT_TRACKING,
  );

  const code = queryParams.get('code');
  const src = queryParams.get('src');
  const email = queryParams.get('email');

  const trackEvent = async (event: TrackEventRequest) => {
    try {
      await Api.eventTracking(event);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error tracking event:', error);
    }
  };

  useEffect(() => {
    if (hasRun || !code || !src) return;

    const payload: TrackEventRequest = {
      eventCategory: TrackEventCategoryEnum.INVITATION_EMAIL,
      eventType: TrackEventTypeEnum.INVITATION_EMAIL_CONTACT_SUPPORT_CLICKED,
      eventDate: `${new Date().toISOString()}`,
      entityId: code,
      details: { src },
    };

    trackEvent(payload);
    sessionStorage.setItem(STORAGE_INVITATION_EMAIL_EVENT_TRACKING, 'true');

    return () => {
      sessionStorage.removeItem(STORAGE_INVITATION_EMAIL_EVENT_TRACKING);
    };
  }, []);

  window.location.href = `mailto:${email}`;

  return null;
};
